<atx-picture-in-picture
  [activate]="pipActive"
  [objectFit]="objectFit"
  (exitPip)="exitPictureInPicture()"
>
  <video
    loop
    playsinline
    disablePictureInPicture
    [poster]="posterUrl"
    #video
    (loadeddata)="this.videoReady.emit()"
    (error)="videoError.emit()"
  >
    <source (error)="videoError.emit()" [src]="url | safeUrl" />
  </video>
</atx-picture-in-picture>
